module.exports = __webpack_public_path__ + "f76e61d41bb28675904f6c199adbf3d1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./assets/demo/desk.jpeg
// module id = ./assets/demo/desk.jpeg
// module chunks = 1